module.exports = __webpack_public_path__ + "img/button.05cb0a5e.png";